import React from 'react';

import { RecursiveShortcodeProps } from './Shortcode';

const Bold = ({ elements, RecursiveShortcode, ...rest }: RecursiveShortcodeProps) => (
  <span style={{ fontWeight: 'bold' }}>
    {RecursiveShortcode ? <RecursiveShortcode elements={elements} {...rest} /> : null}
  </span>
);

Bold.displayName = 'Bold';

export default Bold;
